import React, { Suspense } from 'react';

import { ToastContainer } from '@savgroup-front-common/core/atoms/Toast';
import { BaseLoader } from '@savgroup-front-common/core/molecules/BaseLoader';
import { AppErrorBoundary } from '@savgroup-front-common/core/molecules/ErrorBoundary';
import { ExternalPortal } from '@savgroup-front-common/core/protons/ExternalPortal/ExternalPortal';
import { rem } from '@savgroup-front-common/primitive/helpers/units';

import { useUpdateFavicon } from '@/hooks';
import useGetClientInformation from '@/view/atoms/ClientInformationProvider/hooks/useGetClientInformation';

import Header from './Header/Header';
import { $PageWrapper, $StepWrapper } from './NewDesignLayout.styles';

const NewDesignLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { clientInformation, isLoading } = useGetClientInformation();
  const sellerId = clientInformation?.sellerId ?? clientInformation?.tenantId;

  useUpdateFavicon({ sellerId });

  if (isLoading || !sellerId) {
    return <BaseLoader />;
  }

  return (
    <Suspense fallback={<BaseLoader />}>
      <AppErrorBoundary>
        <$PageWrapper>
          <Header sellerId={sellerId} />
          <$StepWrapper>{children}</$StepWrapper>
        </$PageWrapper>
        <ExternalPortal>
          <ToastContainer topOffset={rem(84)} />
        </ExternalPortal>
      </AppErrorBoundary>
    </Suspense>
  );
};

export default NewDesignLayout;
